var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "reference-layout",
    {
      scopedSlots: _vm._u(
        [
          {
            key: "header",
            fn: function () {
              return [
                _c("reference-header", {
                  attrs: { "header-title": "Типы нагрузок" },
                  scopedSlots: _vm._u([
                    {
                      key: "header-actions",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "layout-header-action" },
                            [
                              _c("c-button", {
                                staticClass: "new-violation",
                                attrs: {
                                  size: "small",
                                  label: "Новый тип нагрузки",
                                  icon: {
                                    icon: "plus",
                                    color: "primary",
                                  },
                                },
                                on: { click: _vm.createNewViolation },
                              }),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
          _vm.itemsOrGroupsAreAvailable
            ? {
                key: "subheader",
                fn: function () {
                  return [
                    _c("div", { staticClass: "subheader__wrapper" }, [
                      _c(
                        "form",
                        {
                          staticClass: "subheader__form",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.applyFilters.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("c-input", {
                            staticClass:
                              "reference-reasons-for-reject-candidate__subheader__search",
                            attrs: {
                              placeholder: "Поиск по наименованию",
                              type: "text",
                              clearable: true,
                              icon: "search",
                            },
                            on: { clearInput: _vm.resetFilters },
                            model: {
                              value: _vm.filters.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "name", $$v)
                              },
                              expression: "filters.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                },
                proxy: true,
              }
            : null,
          {
            key: "list",
            fn: function () {
              return [
                !_vm.isLoading && _vm.isAnyItemExists
                  ? _c("violation-types-group-list", {
                      attrs: {
                        "selected-list-group-items-status":
                          _vm.selectedListGroupItemsStatus,
                        filters: _vm.filters,
                      },
                      on: {
                        "on-delete-list-group-item": _vm.onDeleteListGroupItem,
                        "on-delete-list-group": _vm.onDeleteListGroup,
                        "edit-list-group-item": _vm.onEditListGroupItem,
                        "edit-group": _vm.onGroupEdit,
                      },
                    })
                  : _vm._e(),
                !_vm.itemsOrGroupsAreAvailable && !_vm.isLoading
                  ? _c("div", { staticClass: "no-items" }, [
                      _vm._v("Типов нагрузок пока не добавлено"),
                    ])
                  : _vm._e(),
                !_vm.isAnyItemExists && _vm.areFiltersApplied && !_vm.isLoading
                  ? _c("div", { staticClass: "no-items" }, [
                      _vm._v(
                        " Ничего не найдено. Попробуйте изменить параметры поиска. "
                      ),
                    ])
                  : _vm._e(),
                _vm.isLoading || _vm.isLoadingMoreData
                  ? _c("c-loader", {
                      attrs: {
                        active: _vm.isLoading || _vm.isLoadingMoreData,
                        height: 500,
                        label: "Загрузка типов нагрузок",
                      },
                    })
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
        ],
        null,
        true
      ),
    },
    [
      _c("violation-type-create-modal", {
        ref: "typeModal",
        on: { submitted: _vm.listGroupModalIsSubmitted },
      }),
      _c("create-modal", {
        ref: "groupModal",
        on: { submitted: _vm.groupModalIsSubmitted },
      }),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          !_vm.isLoading
            ? _c("display-shown-items-count", {
                attrs: {
                  "total-items-count": _vm.totalItemsCount,
                  "shown-items-count": _vm.violationsWithoutGroup.length,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }